import { useInView } from "react-intersection-observer";
import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./Default.module.scss";
import classNames from "classnames/bind";
import { useMobileHeaderPeep } from "../../hooks/useMobileHeaderPeep";
import useRouteLoading from "../../hooks/useRouteLoading";

const cx = classNames.bind(styles);

export const slotNameMap = {
  BANNER: "banner",
  HEADER: "header",
  TOP: "top",
  ACCESSORY: "accessory",
  MAIN_TOP: "main-top",
  STICKY_BAR: "sticky-bar",
  PRE_MAIN: "pre-main",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function Default(props: PageProps) {
  const { ref: stickySentinelRef, inView: stickySentinelInView } = useInView({
    initialInView: true,
  });

  const isRouteLoading = useRouteLoading();
  const hasMobileHeaderPeeped = useMobileHeaderPeep();
  const hasHeaderPeeped = hasMobileHeaderPeeped;
  const isListView = props.flags.isListViewOn?.value;
  const isLargeCards = !isListView;

  return (
    <div
      data-layout="Default"
      className={cx("page", {
        "page--largeCards": isLargeCards,
      })}
    >
      <Slot {...props} name={slotNameMap["HEADER"]} />
      <Slot {...props} name={slotNameMap["BANNER"]} className={styles.banner} />
      <main className={cx("pageContainer")} id="main">
        <div className={cx("grid", "grid--top")}>
          <Slot
            {...props}
            name={slotNameMap["BANNER"]}
            className={styles.banner}
          />
          <Slot {...props} name={slotNameMap["TOP"]} className={styles.top} />
        </div>
        <div className={styles.grid}>
          <div
            className={cx("accessoryWrapper", {
              "u-loading": isRouteLoading,
              headerPeeped: hasHeaderPeeped,
              isStuck: !stickySentinelInView,
            })}
          >
            <Slot
              {...props}
              name={slotNameMap["ACCESSORY"]}
              className={cx("accessory", {
                headerPeeped: hasHeaderPeeped,
              })}
            />
          </div>
          <div className={styles.content}>
            <Slot
              {...props}
              name={slotNameMap["MAIN_TOP"]}
              className={cx("mainTop")}
            />
            <div ref={stickySentinelRef} className={styles.stickySentinel} />
            <Slot
              {...props}
              name={slotNameMap["STICKY_BAR"]}
              className={cx("stickyBar", {
                "stickyBar--isStuck": !stickySentinelInView,
                "stickyBar--hasHeaderPeeped": hasHeaderPeeped,
                "u-loading": isRouteLoading,
              })}
            />
            <Slot {...props} name={slotNameMap["PRE_MAIN"]} />
            <Slot
              {...props}
              id="main-content-slot"
              name={slotNameMap["MAIN"]}
              className={cx("mainSlot", {
                "u-loading": isRouteLoading,
                headerPeeped: hasHeaderPeeped,
              })}
            />
          </div>
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} />
    </div>
  );
}
